import type { Color } from './types'

export type ColorType = 'active' | 'inactive' | 'text'

// This also represents the correct order of colors
export const ColorList = [
  'marine',
  'turqoise',
  'purple',
  'azure',
  'tangerine',
  'red',
  'green',
  'lilac',
  'salmon',
  'lime',
  'blue',
  'orange',
  'yellow',
  'teal',
  'indigo',
  'hotpink',
  'yellowGreen',
  'cyan',
  'pink',
  'lavender',
] as const

export type RouteColorName = typeof ColorList[number]

export type ColorPreset = {
  name: RouteColorName
  index: number
  active: Color
  inactive: Color
  text: Color
}

export const ColorMap: Record<RouteColorName, ColorPreset> = {
  azure: {
    index: -1,
    name: 'azure',
    active: '#40B2F9',
    inactive: '#BFE2F8',
    text: '#1994E1',
  },
  blue: {
    index: -1,
    name: 'blue',
    active: '#3F90FA',
    inactive: '#D0E3FB',
    text: '#0D73F8',
  },
  cyan: {
    index: -1,
    name: 'cyan',
    active: '#41C7DE',
    inactive: '#C2E9F0',
    text: '#20A0B7',
  },
  green: {
    index: -1,
    name: 'green',
    active: '#6CD025',
    inactive: '#CAECB1',
    text: '#56A51D',
  },
  hotpink: {
    index: -1,
    name: 'hotpink',
    active: '#F060C7',
    inactive: '#FACBED',
    text: '#CB209A',
  },
  indigo: {
    index: -1,
    name: 'indigo',
    active: '#6C6AF7',
    inactive: '#DAD9FD',
    text: '#4644EA',
  },
  lavender: {
    index: -1,
    name: 'lavender',
    active: '#BE73EA',
    inactive: '#EDD9F9',
    text: '#9E3FD5',
  },
  lilac: {
    index: -1,
    name: 'lilac',
    active: '#D86EE2',
    inactive: '#F2D0F6',
    text: '#C933D6',
  },
  lime: {
    index: -1,
    name: 'lime',
    active: '#BBCC00',
    inactive: '#E8EEA5',
    text: '#8C9900',
  },
  marine: {
    index: -1,
    name: 'marine',
    active: '#476FF1',
    inactive: '#CFD9FC',
    text: '#2450E1',
  },
  orange: {
    index: -1,
    name: 'orange',
    active: '#F46A25',
    inactive: '#F4D0BE',
    text: '#DA500B',
  },
  pink: {
    index: -1,
    name: 'pink',
    active: '#F871A7',
    inactive: '#FDD3E4',
    text: '#E71D6E',
  },
  purple: {
    index: -1,
    name: 'purple',
    active: '#8E6AF3',
    inactive: '#E3D9FC',
    text: '#7045E4',
  },
  red: {
    index: -1,
    name: 'red',
    active: '#F24242',
    inactive: '#FCCFCF',
    text: '#EF1212',
  },
  salmon: {
    index: -1,
    name: 'salmon',
    active: '#F5647C',
    inactive: '#FCD2D9',
    text: '#E63350',
  },
  tangerine: {
    index: -1,
    name: 'tangerine',
    active: '#E59900',
    inactive: '#F0D8A8',
    text: '#B27700',
  },
  teal: {
    index: -1,
    name: 'teal',
    active: '#4BD2BC',
    inactive: '#C4EEE7',
    text: '#289F8B',
  },
  turqoise: {
    index: -1,
    name: 'turqoise',
    active: '#43D072',
    inactive: '#C4EED2',
    text: '#2AA754',
  },
  yellow: {
    index: -1,
    name: 'yellow',
    active: '#D6BA00',
    inactive: '#F0E6A8',
    text: '#A38D00',
  },
  yellowGreen: {
    index: -1,
    name: 'yellowGreen',
    active: '#8EBD00',
    inactive: '#DEF0A8',
    text: '#678A00',
  },
} as const

/** @deprecated - Use ColorMap instead */
export const colors = ColorMap

/** @deprecated - Use ColorList instead */
export const order = ColorList

for (let i = 0; i < order.length; i++) {
  ColorMap[ColorList[i]].index = i
}

export function getPresetByName(name: RouteColorName) {
  return ColorMap[name]
}

export function getOrderedPresetName(index: number): RouteColorName {
  return order[index % 20]
}

export function getOrderedPreset(number: number): ColorPreset {
  return ColorMap[getOrderedPresetName(number)]
}
